<template>
  <div class="table-list" v-loading="loading">
    <div class="table-content">
      <el-table
        :data="listData"
        header-cell-class-name="dark"
        :height="tableHeight"
        stripe
        border
      >
        <table-column label="序号" width="60" type="index" />
        <table-column prop="orderId" label="交易流水号" />
        <table-column prop="transTime" label="交易时间" />
        <table-column prop="merName" label="交易商户" />
        <table-column prop="merNo" label="商户号" />
        <table-column prop="supName" label="供应商" />
        <table-column prop="supId" label="供应商号" />
        <table-column prop="orderAmt" label="交易金额" />
        <table-column prop="riskValue" label="触发风控说明" />
        <table-column prop="riskId" label="规则编号" />
        <table-column prop="bankName" label="渠道路由" />
        <table-column label="交易状态">
          <template slot-scope="scope">{{
            scope.row.status | filterPaymentState
          }}</template>
        </table-column>
        <table-column label="商户通过率">
          <template slot-scope="scope"
            >{{ (scope.row.merOdds * 100).toFixed(2) }}%</template
          >
        </table-column>
        <table-column label="供应商通过率">
          <template slot-scope="scope"
            >{{ (scope.row.supOdds * 100).toFixed(2) }}%</template
          >
        </table-column>

        <el-table-column width="80">
          <div slot="header" class="fixed-right-column">操作</div>
          <span
            class="active pointer"
            slot-scope="scope"
            @click="toDetailPage(scope.row)"
            >查看</span
          >
        </el-table-column>
        <!-- 表格数据 end -->
      </el-table>
    </div>
  </div>
</template>

<script>
import mixin from '@/mixins/dataListHeight.js'
export default {
  mixins: [mixin],
  props: {
    loading: {
      type: Boolean,
      default: true,
      comment: '加载状态'
    },
    listData: {
      type: Array,
      default() {
        return []
      },
      comment: '列表数据'
    }
  },

  methods: {
    toDetailPage(row) {
      this.$router.push({
        path: `/home/riskControlExecute/details/${row.merNo}/${row.supId}`,
        query: {
          tradeDate: row.transTime,
          merName: escape(row.merName),
          supName: escape(row.supName)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/Common/tableList.scss';
</style>
